import {Base} from "@/api/Base"

export class OvertimeApplicationEdit extends Base {
    path = "overtimeApplication/edit"
}